"use strict";

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Map } from 'immutable';
import { AppDispatcher } from 'Dispatcher';
import { TreeListConstants } from "Constants/TreeListConstants";
import { TableToolBarConstants } from "Constants/Table/TableToolBarConstants";
import Uuid from "uuid";
import { FormEditConstants } from "Constants/Forms/FormEditConstants";
import { D5TableConstants } from "Constants/Table/D5TableConstants";

var TreeListContainerClass =
/*#__PURE__*/
function () {
  function TreeListContainerClass() {
    _classCallCheck(this, TreeListContainerClass);

    _defineProperty(this, "_stores", new Map());
  }

  _createClass(TreeListContainerClass, [{
    key: "create",

    /**
     * @param {TreeListStoreClass} store
     * @param {string} UUID
     * @param {object} rest
     */
    value: function create(_ref) {
      var store = _ref.store,
          UUID = _ref.UUID,
          rest = _objectWithoutProperties(_ref, ["store", "UUID"]);

      this._stores = this._stores.set(UUID, store);
      store.initialize(rest);
    }
  }, {
    key: "del",
    value: function del(_ref2) {
      var UUID = _ref2.UUID;
      this._stores = this._stores.delete(UUID);
    }
  }, {
    key: "get",
    value: function get(UUID) {
      return this._stores.get(UUID);
    }
  }, {
    key: "cloneByForm",
    value: function cloneByForm(_ref3) {
      var prev = _ref3.prev,
          next = _ref3.next;
      var store = this.byFormUUID(prev);

      if (store) {
        store.formUUID(next);
        this._stores = this._stores.set(Uuid(), store);

        var uuid = this._stores.findKey(function (s) {
          return s.formUUID() === prev;
        });

        uuid && this.del({
          UUID: uuid
        });
      }
    }
  }, {
    key: "byFormUUID",
    value: function byFormUUID(formUUID) {
      return this._stores.find(function (st) {
        return st.formUUID() === formUUID;
      });
    }
  }, {
    key: "edtClicked",
    value: function edtClicked(options) {
      var store = this.byFormUUID(options.UUID);
      store && store.editButtonEvent(options);
    }
  }, {
    key: "showHdrFltrBtnClicked",
    value: function showHdrFltrBtnClicked(options) {
      var store = this.byFormUUID(options.formUUID);
      store && store.showHeaderFilterBtnClicked(options);
    }
  }, {
    key: "selectionClicked",
    value: function selectionClicked(options) {
      var store = this.byFormUUID(options.formUUID);
      store && store.selectionClicked(options);
    }
  }, {
    key: "showColumnChooserClicked",
    value: function showColumnChooserClicked(_ref4) {
      var formUUID = _ref4.formUUID;
      var store = this.byFormUUID(formUUID);
      store && store.showColumnChooserClicked();
    }
  }, {
    key: "showTableModalFilter",
    value: function showTableModalFilter(_ref5) {
      var formUUID = _ref5.formUUID;
      var store = this.byFormUUID(formUUID);
      store && store.showTableModalFilter();
    }
  }, {
    key: "deleteRows",
    value: function deleteRows(_ref6) {
      var formUUID = _ref6.formUUID,
          props = _objectWithoutProperties(_ref6, ["formUUID"]);

      var store = this.byFormUUID(formUUID);
      store && store.deleteRows(props);
    }
  }, {
    key: "resetSettings",
    value: function resetSettings(_ref7) {
      var formUUID = _ref7.formUUID;
      var store = this.byFormUUID(formUUID);
      store && store.resetSettings();
    }
  }, {
    key: "loadContextMenu",
    value: function loadContextMenu(_ref8) {
      var formUUID = _ref8.formUUID,
          dataContextMenu = _ref8.dataContextMenu;
      var store = this.byFormUUID(formUUID);
      store && store.loadContextMenu(dataContextMenu);
    }
  }, {
    key: "goto",
    value: function goto(_ref9) {
      var formUUID = _ref9.formUUID,
          rest = _objectWithoutProperties(_ref9, ["formUUID"]);

      var store = this.byFormUUID(formUUID);
      store && store.goto(rest);
    }
  }, {
    key: "refreshTableAfterSubmittedForm",
    value: function refreshTableAfterSubmittedForm(_ref10) {
      var formUUID = _ref10.formUUID,
          rest = _objectWithoutProperties(_ref10, ["formUUID"]);

      var store = this.byFormUUID(formUUID);
      store && store.refreshTableAfterSubmittedForm(rest);
    }
  }, {
    key: "focusRowAfterEdit",
    value: function focusRowAfterEdit() {
      //TODO обновлять только определенный стор + переделать в таблицах
      this._stores.forEach(function (store) {
        store.focusRowAfterEdit({});
      });
    }
  }]);

  return TreeListContainerClass;
}();

export var TreeListContainer = new TreeListContainerClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case TreeListConstants.TREE_VIEW_SET_STORE:
      TreeListContainer.create(action.options);
      break;

    case TreeListConstants.TREE_VIEW_DESTROY_STORE:
      TreeListContainer.del(action);
      break;

    case TreeListConstants.TREE_VIEW_UPDATE_UUID:
      TreeListContainer.cloneByForm(action);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_EDIT_BTN_CLICKED:
      TreeListContainer.edtClicked(action.options);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_SHOW_FILTER_BTN_CLICKED:
      TreeListContainer.showHdrFltrBtnClicked(action.options);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_SELECTION_BTN_CLICKED:
      TreeListContainer.selectionClicked(action.options);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_COLUMN_CHOOSER_BTN_CLICKED:
      TreeListContainer.showColumnChooserClicked(action.options);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_SHOW_FILTER_MODAL_CLICKED:
      TreeListContainer.showTableModalFilter(action.options);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_DELETE_ROWS_CLICKED:
      TreeListContainer.deleteRows(action.options);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_RESET_TABLE_SETTINGS:
      TreeListContainer.resetSettings(action.options);
      break;

    case TableToolBarConstants.LOAD_TABLE_CONTEXT_MENU_DATA:
      TreeListContainer.loadContextMenu(action);
      break;

    case TableToolBarConstants.TOOLBAR_TABLE_GOTO_CLICKED:
      TreeListContainer.goto(action.options);
      break;

    case FormEditConstants.FORM_EDIT_SUBMITED:
      TreeListContainer.refreshTableAfterSubmittedForm(action);
      break;

    case D5TableConstants.D5_TABLE_FOCUS_LAST_ROW:
      TreeListContainer.focusRowAfterEdit(action.options);
      break;

    default:
      return true;
  }
});